import {isComponentFilename} from './components';
import {
  PROJECTED_PACKAGE_JSON_FILENAME,
  PROJECTED_INDEX_FILENAME,
  PROJECTED_THEME_FILENAME,
  PROJECTED_GLOBALS_FILENAME,
  SKILLS_DIRECTORY,
} from '../constants';

export const isSkillFile = (path: string): boolean =>
  path.startsWith(`/${SKILLS_DIRECTORY}/`) ||
  path.startsWith(`${SKILLS_DIRECTORY}/`);

export const isProjectedFile = (path: string): boolean =>
  isComponentFilename(path) ||
  path === PROJECTED_PACKAGE_JSON_FILENAME ||
  path === PROJECTED_INDEX_FILENAME ||
  path === PROJECTED_THEME_FILENAME ||
  path === PROJECTED_GLOBALS_FILENAME;
